import '../css/app.scss'

import './countdown.js'
import './global.js';
